"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _enums = _interopRequireDefault(require("../enums.js"));
var _createPropertyOrder = _interopRequireDefault(require("../create-property-order.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const componentNames = ['figure'];
const config = {
  styleProperties: (0, _createPropertyOrder.default)(_enums.default.properties.FIGURE_COLOR, 30)
};
var _default = componentNames.reduce((obj, name) => Object.assign(obj, {
  [name]: config
}), {});
exports.default = _default;